export function createListReplaceCb() {
  return function innerListReplace(match, listType, listAttributes, listBody) {
    let liIndex = 0;
    if (listAttributes && /start="([0-9]+)"/i.test(listAttributes)) {
      liIndex = (/start="([0-9]+)"/i.exec(listAttributes)[1]) - 1;
    }
    let plainListItem = `\n${listBody.replace(/<li[^>]*>(((?!<li[^>]*>)(?!<\/li>).)*)<\/li>/gi, (str, listItem) => {
      let actSubIndex = 0;
      const plainListLine = listItem.replace(/(^|(<br \/>))(?!<p>)/gi, () => {
        if (listType === 'o' && actSubIndex === 0) {
          liIndex += 1;
          actSubIndex += 1;
          return `\n\t${liIndex}. `;
        }
        return '\n\t• ';
      });
      return plainListLine;
    })}\n`;

    // Returning beginning ul or ol as plain text to fill Pell content for correct filled Label
    if (plainListItem === '\n\n' && listType === 'o') {
      plainListItem = '\t1. ';
    } else if (plainListItem === '\n\n' && listType !== 'o') {
      plainListItem = '\t• ';
    }
    return plainListItem;
  };
}

export function toPlaintext(htmlText) {
  if (!htmlText) { return ''; }

  // removel all \n linebreaks
  let tmp = String(htmlText).replace(/\n|\r/g, ' ');

  // remove everything before and after <body> tags including the tag itself
  const bodyEndMatch = tmp.match(/<\/body>/i);
  if (bodyEndMatch) {
    tmp = tmp.substring(0, bodyEndMatch.index);
  }
  const bodyStartMatch = tmp.match(/<body[^>]*>/i);
  if (bodyStartMatch) {
    tmp = tmp.substring(bodyStartMatch.index + bodyStartMatch[0].length, tmp.length);
  }

  // remove inbody scripts and styles
  tmp = tmp.replace(/<(script|style)( [^>]*)*>((?!<\/\1( [^>]*)*>).)*<\/\1>/gi, '');

  // remove all tags except that are being handled separately
  tmp = tmp.replace(/<(\/)?((?!h[1-6]( [^>]*)*>)(?!img( [^>]*)*>)(?!a( [^>]*)*>)(?!ul( [^>]*)*>)(?!ol( [^>]*)*>)(?!li( [^>]*)*>)(?!p( [^>]*)*>)(?!div( [^>]*)*>)(?!td( [^>]*)*>)(?!br( [^>]*)*>)[^>/])[^<>]*>/gi, '');

  // remove empty list items
  tmp = tmp.replace(/<li><br><\/li>/gi, '');

  // format lists (ol and ul)
  while (/<(o|u)l[^>]*>(.*)<\/\1l>/gi.test(tmp)) {
    tmp = tmp.replace(/<(o|u)l([^>]*)>(((?!<(o|u)l[^>]*>)(?!<\/(o|u)l>).)*)<\/\1l>/gi, createListReplaceCb());
  }

  // replace <br>s, <td>s, <divs> and <p>s with linebreaks
  tmp = tmp.replace(/<br( [^>]*)*>|<p( [^>]*)*>|<\/p( [^>]*)*>|<div( [^>]*)*>|<\/div( [^>]*)*>|<td( [^>]*)*>|<\/td( [^>]*)*>/gi, '\n');

  // replace <a href>b<a> links with b (href) or as described in the linkProcess function
  tmp = tmp.replace(/<a[^>]*href="([^"]*)"[^>]*>([^<]+)<\/a[^>]*>/gi, (str, href, linkText) => ` [${linkText}] (${href}) `);

  // remove whitespace from empty lines excluding nbsp
  tmp = tmp.replace(/\n[ \f]*/gi, '\n');

  // remove duplicated empty lines
  tmp = tmp.replace(/\n\n\n+/gi, '\n\n');

  // remove duplicated spaces including non braking spaces
  // tmp = tmp.replace(/( )+/gi, ' ');
  tmp = tmp.replace(/&nbsp;/gi, ' ');

  // remove line starter spaces
  tmp = tmp.replace(/\n +/gi, '\n');

  // remove content starter spaces
  tmp = tmp.replace(/^ +/gi, '');

  // remove first empty line
  while (tmp.length > 0 && tmp.indexOf('\n') === 0) {
    tmp = tmp.substring(1);
  }

  // remove new lines at the end
  if (tmp.length !== 0 && tmp.lastIndexOf('\n') === tmp.length - 1) {
    while (tmp.lastIndexOf('\n') === tmp.length - 1) {
      tmp = tmp.substring(0, tmp.length - 1);
    }
  }

  return tmp;
}

export function toHtml(plainText) {
  if (!plainText) { return ''; }
  // replace all line breaks with paragraph tags
  let tmp = `<p>${String(plainText).replace(/\n|\r/g, '</p>\n<p>')}</p>`;

  // add unordered lists to all bullets
  tmp = tmp.replace(/<p>\t• (.+)<\/p>/gi, '<ul><li>$1</li></ul>');
  tmp = tmp.replace(/<\/li><\/ul>\n<ul><li>/gi, '</li><li>');

  // add ordered lists to all numbers
  tmp = tmp.replace(/<p>\t[0-9]+\. ([^\n]+)<\/p>/gi, '<ol><li>$1</li></ol>');
  tmp = tmp.replace(/<\/li><\/ol>\n<ol><li>/gi, '</li><li>');

  // replace \n\n as a single paragraph
  tmp = tmp.replace(/\n<p><\/p>\n/gi, '');
  tmp = tmp.replace(/<\/p>\n<p><\/p>\n<p>/gi, '</p><p>');

  // add single line break inside paragraph (shift + enter)
  tmp = tmp.replace(/<\/p>\n<p>/gi, '<br>');

  // remove any breaks following ul and ol tags
  tmp = tmp.replace(/<\/ul>\n<br \/>/gi, '</ul>');
  tmp = tmp.replace(/<\/ol>\n<br \/>/gi, '</ol>');

  // remove all leftover newline characters
  tmp = tmp.replace(/\n/g, '');

  return tmp;
}
